import { Component, TemplateRef } from '@angular/core';
import { ToastService } from '../toast.service';


@Component({
  selector: 'app-toast-container',
  template: `
    <ngb-toast
      *ngFor="let toast of toastService.toasts"
      [class]="toast.classname"
      [autohide]="true"
      [delay]="toast.delay || 5000"
      (hidden)="toastService.remove(toast)"
    >
      <ng-template [ngIf]="isTemplate(toast.textOrTpl)" [ngIfElse]="text">
        <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
      </ng-template>

      <ng-template #text>{{ displayText(toast) }}</ng-template>
    </ngb-toast>
  `,
  host: { '[class.ngb-toasts]': 'true' }
})
export class ToastContainerComponent {
  constructor(public toastService: ToastService) { }

  isTemplate(textOrTpl: any): boolean {
    return textOrTpl instanceof TemplateRef;
  }

  /** Legacy toasts used `message` / `errorMessage` instead of `textOrTpl`. */
  displayText(toast: any): string {
    const t = toast?.textOrTpl ?? toast?.message ?? toast?.errorMessage ?? toast?.internalErrorMessage;
    return t != null ? String(t) : '';
  }
}